import { format } from 'date-fns'
import { tz } from '@date-fns/tz'
import { asISODate } from 'lib/helpers/asISODate/asISODate'

interface Params {
  timeZone: string
}

export const getTodayInTimeZone = ({ timeZone }: Params): ISODate =>
  asISODate(format(Date.now(), 'yyyy-MM-dd', { in: tz(timeZone) }))
